import type { RouterConfig } from "@nuxt/schema";
import type { RouterOptions, RouteMeta } from "vue-router";

import youtube from "./application/youtube/youtube.router";

export default {
  // https://router.vuejs.org/api/interfaces/routeroptions#routes
  routes: (_routes) => [
    {
      name: "index",
      path: "/",
      component: () => import("~/pages/index.vue")
    },
    {
      path: "/app",
      component: () => import("~/pages/_.vue"),
      children: [
        {
          path: "youtube-thumbnail-downloader",
          redirect: { name: "youtube.thumbnail.downloader.index" } // Redirect to a named route
        },
        { ...youtube }
      ]
    }
  ]
} satisfies RouterConfig;
